export default function rlxLocatorTabs() {
    const $tabs = $('[data-tab]');
    const $tabsContent = $('[data-tab-content]');
    const currentClass = 'is-current';

    $tabs.on('click', function handleTabs() {
        const $selectedTab = $(this);
        const tabId = $selectedTab.attr('data-tab');

        $tabs.removeClass(currentClass);
        $tabsContent.removeClass(currentClass);

        $selectedTab.addClass(currentClass);
        $(tabId).addClass(currentClass);
    });
}
